// Get user role from localStorage
export function getCurrentUserRole() {
  try {
    // Try userInfo first (your current format)
    let user = JSON.parse(localStorage.getItem('userInfo') || '{}')
    if (user.role) {
      return user.role.toLowerCase()
    }
    
    // Fallback to user if userInfo doesn't exist
    user = JSON.parse(localStorage.getItem('user') || '{}')
    if (user.role) {
      return user.role.toLowerCase()
    }
    
    // Default role if no valid user data is found
    return 'patient' // Default role
  } catch (error) {
    console.error('Error getting user role:', error)
    return 'patient'
  }
}

// Filter menu items based on user role using the roles array in menu items
export function filterMenuByRole(menuItems, userRole) {
  if (!userRole) return []
  
  return menuItems.filter(item => {
    // Check if main item is allowed for this role
    const itemAllowed = item.roles && item.roles.includes(userRole)
    
    if (!itemAllowed) return false
    
    // If item has subItems, filter them too
    if (item.subItems && item.subItems.length > 0) {
      const filteredSubItems = item.subItems.filter(subItem => 
        subItem.roles && subItem.roles.includes(userRole)
      )
      
      // Create a copy to avoid mutating original menu
      const itemCopy = { ...item, subItems: filteredSubItems }
      
      // If no subitems are allowed, don't show the main item
      if (filteredSubItems.length === 0) return false
      
      // Replace the item's subItems with filtered ones
      Object.assign(item, itemCopy)
    }
    
    return true
  })
}